import React from "react";
import "./scss/_navigation.scss";
import ClassplusLogo from "./images/classplusLogo.svg";
import PRTLogo from "./images/prtLogo.jpeg";
export const Navigation = (props) => {
  return (
    <div className="navigation">
      <div className="navigation__logo">
        <img
          src={ClassplusLogo}
          alt="Classplus"
          className="navigation__logo--img"
        />
      </div>
      <div className="navigation__logo2">
        <img src={PRTLogo} alt="Classplus" className="navigation__logo2--img" />
      </div>
    </div>
  );
};
